import React from 'react';
import styles from './styles/Snackbar.module.scss';

type SnackbarProps = {
  children: React.JSX.Element | string | (React.JSX.Element | string)[];
  fade?: boolean;
  inline?: boolean;
  margin?: 'top' | 'bottom' | 'y';
  type: 'info' | 'success' | 'error';
};

const Snackbar: React.FunctionComponent<SnackbarProps> = (props: SnackbarProps) => {
  const [visible, setVisible] = React.useState<boolean>(false);

  React.useEffect(() => {
    setVisible(true);
    setTimeout(() => {
      setVisible(false);
    }, 5500);
  }, []);

  return (
    <div
      className={`${styles.snackbar} ${styles[props.type]} ${visible ? styles.visible : undefined} ${
        props.margin ? styles[`margin-${props.margin}`] : undefined
      } ${props.fade ? styles.fade : undefined} ${props.inline ? styles.inline : undefined}`}
    >
      <p>{props.children}</p>
    </div>
  );
};

export default Snackbar;
